import curd from '../curd'

const BASE_PATH = '/capture/effective/data'

export default curd(BASE_PATH, {
  getGranularity: data => ({
    url: `${BASE_PATH}/granularity`,
    method: 'POST',
    data: data
  }),
  getChartData: data => ({
    url: `${BASE_PATH}/granularity/device`,
    method: 'POST',
    data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/Effective.js